// auth 2.0

import {
  SET_SHOW_REFERRAL_POPUP,
  SET_PAYMENT_LENGTH,
  SET_PAYMENTS_HISTORY_DATA,
  SET_REFERRAL_CODE_DATA,
  SET_USER_COUNTRY,
  FETCH_SUBSCRIPTION,
  UPDATE_SUBSCRIPTION,
  SET_DAYPASS_DATA,
  SET_PLAN_LENGTH,
  SET_MEMBERSHIP,
  SET_IS_ONE_YEAR_PREMIUM_PLAN,
  SET_IS_CHECKOUT_SECTION_VISIBLE_ON_MOBILE,
  SET_EXPERT_CODE,
  SET_SURVEY_INFO,
  SET_INPUT_FORM_INFO,
  SET_IS_REFERRAL_CODE_APPLIED,
  SET_OPTION_SELECTED_IN_CHECKOUT_MODAL,
} from "redux/actions/actionTypes";

const initialState = {
  showReferralPopup: false, // This state is related to pricing page. if true, show referral Popup
  paymentLength: "yearly",
  paymentsHistoryData: null,
  referralCodeData: null,
  subscriptionData: null,
  dayPassData: null,
  userCountry: null,
  isReferralCodeApplied: false,
  //  S of pricing page related states
  planLength: "long",
  membership: "premium",

  isOneYearPremiumPlan: false,
  isCheckoutSectionVisibleOnMobile: false,
  optionSelectedInCheckoutModal: 0,
  // E of pricing page related states

  // S of promotion pricing page related states
  expertCode: undefined,
  surveyInfo: null,
  inputFormInfo: null,
  // E of promotion pricing page related states
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_SHOW_REFERRAL_POPUP:
      return {
        ...state,
        showReferralPopup: action.payload,
      };
    case SET_PAYMENT_LENGTH:
      return {
        ...state,
        paymentLength: action.payload,
      };
    case SET_PAYMENTS_HISTORY_DATA:
      return {
        ...state,
        paymentsHistoryData: action.payload,
      };
    case SET_REFERRAL_CODE_DATA:
      return {
        ...state,
        referralCodeData: action.payload,
      };
    case SET_USER_COUNTRY:
      return {
        ...state,
        userCountry: action.payload,
      };
    case SET_IS_REFERRAL_CODE_APPLIED:
      return {
        ...state,
        isReferralCodeApplied: action.payload,
      };
    case SET_DAYPASS_DATA:
      return {
        ...state,
        dayPassData: action.payload,
      };
    case FETCH_SUBSCRIPTION:
      return {
        ...state,
        subscriptionData: action.payload,
      };
    case UPDATE_SUBSCRIPTION:
      return {
        ...state,
        subscriptionData: action.payload,
      };

    // S of pricing page related reducers
    case SET_PLAN_LENGTH:
      return {
        ...state,
        planLength: action.payload,
      };
    case SET_MEMBERSHIP:
      return {
        ...state,
        membership: action.payload,
      };
    case SET_IS_ONE_YEAR_PREMIUM_PLAN:
      return {
        ...state,
        isOneYearPremiumPlan: action.payload,
      };
    case SET_IS_CHECKOUT_SECTION_VISIBLE_ON_MOBILE:
      return {
        ...state,
        isCheckoutSectionVisibleOnMobile: action.payload,
      };
    case SET_OPTION_SELECTED_IN_CHECKOUT_MODAL:
      return {
        ...state,
        optionSelectedInCheckoutModal: action.payload,
      };
    // E of pricing page related reducers

    case SET_EXPERT_CODE:
      return {
        ...state,
        expertCode: action.payload,
      };

    case SET_SURVEY_INFO:
      return {
        ...state,
        surveyInfo: action.payload,
      };

    case SET_INPUT_FORM_INFO:
      return {
        ...state,
        inputFormInfo: action.payload,
      };

    default:
      return state;
  }
};
